import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import eitHigherEdInit from './eit-hei.png';
import eitRawMaterials from './eit-rm-logo_600px.png';
import fundedByEu from './eu_funded_en.jpg';
import healthHollandLogo from './health-holland.png';

export default function Sponsors() {
  return (
    <>
      <h2 className="text-center my-5">Collaborations</h2>
      <Container>
        <Row>
          <Col md={6}>
            <h6>Talent-CGT</h6>
            <p className="text-sm">
              Talent-CGT is a European initiative to train the next generation of
              cell and gene therapy specialists. It builds open digital tools and
              education modules that bring advanced therapy skills into classrooms
              and labs.
            </p>
            <p className="text-sm">
              This project receives funding from the European Institute of Innovation
              and Technology (EIT), a body of the European Union, under the Horizon
              Europe program.
            </p>
            <div className="d-flex gap-2 align-items-center">
              <img height={70} src={eitRawMaterials} alt="EIT raw materials logo" />
              <img height={35} src={fundedByEu} alt="Funded by EU logo" />
              <img height={80} src={eitHigherEdInit} alt="EIT higher education initiative logo" />
            </div>
          </Col>
          <Col md={6}>
            <h6>PRIME-AI</h6>
            <p className="text-sm">
              PRIME-AI develops next-generation gene therapies by combining prime
              editing with artificial intelligence. The project creates smarter
               design tools, a new editing system, and a robust assay to make
              advanced therapies safer and more precise.
            </p>
            <p className="text-sm">
              The collaboration project PRIME-AI is co-funded by PPP Subsidy
              awarded by Health~Holland, Top Sector Life Sciences & Health, to
              stimulate public-private partnerships.
            </p>
            <img height={30} src={healthHollandLogo} alt="Health~Holland logo" className="mx-auto d-block" />
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md={{ span: 6, offset: 3}}>
            <h6>IPCEI P-SMaRT</h6>
            <p className="text-sm">
              IPCEI P-SMaRT accelerates scalable manufacturing platforms for rare
              disease gene therapies. The project focuses on Duchenne muscular
              dystrophy and Diamond-Blackfan anemia to make advanced treatments
              more accessible.
            </p>
            <p className="text-sm">
              This project has received funding under the Important Projects of Common
              European Interest (IPCEI) program.
            </p>
            <img height={40} src={fundedByEu} alt="Funded by EU logo" className="d-block mx-auto" />
          </Col>
        </Row>
      </Container>
    </>
  )
}
